import { IPageDictionaryApi } from '@/types/dictionary';

export class PageDictionaryItem {
    code: string;
    id: number;
    name: string;
    sourceId: number;

    constructor(data: IPageDictionaryApi) {
        this.id = data.id;
        this.name = data.name;
        this.code = data.code;
        this.sourceId = data.source_id;
    }
}
